import React from 'react';
import { Grid, TextField, MenuItem, FormControlLabel, Checkbox } from '@mui/material';
import SectionTitle from '../../../ui/sectionTitle';
import SimpleDatePicker from '../../../ui/simpleDatePicker';
import CustomSelect from '../../../common/customSelect';
import { useQuery } from 'react-query';
import { ValidDataService } from '../../../../service/validDataService';

function ValidContactPropertiesForm({ formik }) {
    const {data: conatctLensType, isLoading: contactLensTypeLoading, error: lensTypeError } = useQuery('lensTypes', ValidDataService.getContactLensTypes)
    const {data: contactLensMaterial, isLoading: contactLensMaterialLoading, error: contactLensMaterialError } = useQuery('contactLensMaterial', ValidDataService.getContactLensMaterial)
    const { data: contactlenswearschedule, isLoading: contactLensWearScheduleLoading, error: contactLensWearScheduleError } = useQuery('contactLensWearSchedule', ValidDataService.getContactLensWearSchedule);

    return (
        <>
            <Grid item xs={12}>
                <SectionTitle title="Contact Lens Properties" />
            </Grid>
            <Grid container spacing={2} >
                <Grid item xs={12} sm={6}  mt={2}>
                    <CustomSelect formik={formik} options={conatctLensType?.data || []} isLoading={contactLensTypeLoading} error={lensTypeError} value={formik.values.properties.contactLensType} name="properties.contactLensType" label='Type' />
                    {/* <TextField
                        select
                        id="contactType"
                        name="properties.contactType"
                        label="Contact Type"
                        size="small"
                        fullWidth
                        value={formik.values.properties.contactType}
                        onChange={formik.handleChange}
                        error={formik.touched.properties?.contactType && Boolean(formik.errors.properties?.contactType)}
                        helperText={formik.touched.properties?.contactType && formik.errors.properties?.contactType}
                    >
                        {contactTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                                {type}
                            </MenuItem>
                        ))}
                    </TextField> */}
                </Grid>
                <Grid item xs={12} sm={6}  mt={2}>
                    <CustomSelect formik={formik} options={contactlenswearschedule?.data || []} isLoading={contactLensWearScheduleLoading} error={contactLensWearScheduleError} value={formik.values.properties.wearSchedule} name="properties.wearSchedule" label='Wear Schedule' />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <CustomSelect formik={formik} options={contactLensMaterial?.data || []} isLoading={contactLensMaterialLoading} error={contactLensMaterialError} value={formik.values.properties.material} name="properties.material" label='Material' />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="packSize"
                        name="properties.packSize"
                        label="Pack Size"
                        type="number"
                        size="small"
                        fullWidth
                        value={formik.values.properties.packSize}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="sphere"
                        name="properties.sphere"
                        label="Sphere"
                        type="number"
                        size="small"
                        fullWidth
                        value={formik.values.properties.sphere}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="cyl"
                        name="properties.cyl"
                        label="Cylinder"
                        type="number"
                        size="small"
                        fullWidth
                        value={formik.values.properties.cyl}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="axis"
                        name="properties.axis"
                        label="Axis"
                        type="number"
                        size="small"
                        fullWidth
                        value={formik.values.properties.axis}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="bc"
                        name="properties.bc"
                        label="BC"
                        type="number"
                        size="small"
                        fullWidth
                        value={formik.values.properties.bc}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="dia"
                        name="properties.dia"
                        label="Diameter"
                        type="number"
                        size="small"
                        fullWidth
                        value={formik.values.properties.dia}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="color"
                        name="properties.color"
                        label="Color"
                        size="small"
                        fullWidth
                        value={formik.values.properties.color}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id='isTrial'
                                name="properties.isTrial"
                                checked={formik.values.properties.isTrial}
                                onChange={formik.handleChange}
                                color="primary"
                            />
                        }
                        label="Is Trial"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SimpleDatePicker
                        label="Expiry Date"
                        onChange={(value) => formik.setFieldValue('properties.expirationDate', value)}
                        value={formik.values.properties.expirationDate}
                    />
                </Grid>
            </Grid>

        </>
    );
}

export default ValidContactPropertiesForm;